/**
 * Labeled field row for details views (icon + label + value).
 */

import * as React from 'react';
import { type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Props for {@link DetailField}. */
interface DetailFieldProps {
  label: string;
  value: React.ReactNode;
  icon?: LucideIcon;
  className?: string;
  vertical?: boolean;
}

/** Labeled field used in entity details views. */
export const DetailField: React.FC<DetailFieldProps> = ({
  label,
  value,
  icon: Icon,
  className,
  vertical = false,
}) => {
  return (
    <div className={cn('detail-field', vertical && 'detail-field-vertical', className)}>
      <div className="flex items-center gap-2 min-w-0">
        {Icon && <Icon className="w-4 h-4 shrink-0 text-muted-foreground" />}
        <span className="detail-field-label">{label}</span>
      </div>
      <span className="detail-field-value">{value}</span>
    </div>
  );
};
